"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _decoration = require("@/api/decoration");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DecorationPlatformRule',
  data: function data() {
    return {
      loading: false,
      rules: {
        items: [],
        ackedRules: 0,
        totalRules: 0
      }
    };
  },
  created: function created() {
    this.reload();
  },
  methods: {
    reload: function reload() {
      var _this = this;
      this.loading = true;
      (0, _decoration.decorationPlatformRuleApi)().then(function (data) {
        _this.rules = data || {
          items: [],
          ackedRules: 0,
          totalRules: 0
        };
      }).finally(function () {
        _this.loading = false;
      });
    },
    runAction: function runAction(id, action) {
      var _this2 = this;
      (0, _decoration.decorationPlatformRuleActionApi)(id, {
        action: action
      }).then(function () {
        _this2.$message.success('已更新');
        _this2.reload();
      });
    }
  }
};